/*!
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { EHarshDrivingEventClassification } from '../../../core/models';

@Component({
  selector: 'fm-harsh-driving-event-balloon-title',
  templateUrl: './harsh-driving-event-balloon-title.component.html',
  styleUrls: ['./harsh-driving-event-balloon-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HarshDrivingEventBalloonTitleComponent {
  @Input()
  classification: EHarshDrivingEventClassification;

  EHarshDrivingEventClassification = EHarshDrivingEventClassification;
}
